import type { RouteLocationNormalized, NavigationGuardNext, RouteRecordRaw } from 'vue-router'
import { Site, SLD } from '@patsnap-utils/biz';

interface RedirectRule {
    pattern: RegExp
    replacement: string
}

const redirectRules: RedirectRule[] = [
    { pattern: /^\/results\/standard(?=\/|$|\?)/, replacement: 'results/#/standard' },
    { pattern: /^\/results\/design(?=\/|$|\?)/, replacement: 'results/#/design' },
    { pattern: /^\/results\/analysis(?=\/|$|\?)/, replacement: 'results/#/analysis' },
    { pattern: /^\/technology-roadmap\/#\/create$/, replacement: 'rd/#/roadmap/create' },
    { pattern: /^\/technology-roadmap\/#\/detail(\/.*)?$/, replacement: 'roadmap-view/#/detail$1' },
    { pattern: /^\/technology-roadmap(\/|\/#|\/#\/)?$/, replacement: 'rd/#/roadmap' },
    { pattern: /^\/air\/#\/page(\/.*)?$/, replacement: 'page$1' },
    { pattern: /^\/material(\/|\/#|\/#\/)?$/, replacement: 'home' },
    { pattern: /^\/material\/search(\/|\/#|\/#\/)?$/, replacement: 'home' },
    { pattern: /^\/home\/chat(\/|\/#|\/#\/)?$/, replacement: 'home' },
    { pattern: /^\/home\/search(\/|\/#|\/#\/)?$/, replacement: 'home' },
    { pattern: /^\/material\/chat(\/|\/#|\/#\/)?$/, replacement: 'home' },
    { pattern: /^\/air\/#\/user-setting\/package(\/|\/#|\/#\/)?$/, replacement: 'user-setting/package' },
    { pattern: /^\/air\/#\/user-setting\/amount(\/|\/#|\/#\/)?$/, replacement: 'user-setting/amount' },
    { pattern: /^\/air(\/|\/#|\/#\/)?(\?.*)?$/, replacement: 'home' },
    { pattern: /^\/newsletter\/#\/detail\/(\d+)(?=\/|$|\?)/, replacement: 'monitor/#/report/$1' },
    { pattern: /^\/newsletter\/#\/mySubscription(?=\/|$|\?)/, replacement: 'monitor/#/my' },
    { pattern: /^\/newsletter\/#\/topics(?=\/|$|\?)/, replacement: 'monitor/#/topics' },
    { pattern: /^\/newsletter\/#\/subscription(?=\/|$|\?)/, replacement: 'monitor/#/subscription' },
    { pattern: /^\/newsletter\/#\/result(?=\/|$|\?)/, replacement: 'monitor/#/result' },
    { pattern: /^\/newsletter(?=\/|$|\?)/, replacement: 'monitor' },
    { pattern: /^\/graph\/(.+)/, replacement: 'rd/#/graph/$1' },
    { pattern: /^\/graph(\/)?$/, replacement: 'rd/#/graph' },
    { pattern: /^\/roadmap\/create(\/)?$/, replacement: 'rd/#/roadmap/create' },
    { pattern: /^\/roadmap(\/)?$/, replacement: 'rd/#/roadmap' },
    // IP 相关路由重定向 checking
    { pattern: /^\/ai-drafting\/novelty-check-report(\/.*)?(?=\/|$|\?)/, replacement: 'ip/checking/#/novelty-check-report$1' },
    { pattern: /^\/ai-drafting\/fto-pro\/([^/?]+)/, replacement: 'ip/checking/#/fto-pro?task_id=$1' },
    { pattern: /^\/ai-drafting\/design-fto\/([^/?]+)/, replacement: 'ip/checking/#/design-fto?task_id=$1' },
    { pattern: /^\/ai-ip\/image-fto-search\/([^/?]+)/, replacement: 'ip/#/home?agent=design_infringement' },
    // 新老要并存,暂时不做重定向
    // { pattern: /^\/ai\/agent-flow\/([^/?]+)/, replacement: 'ip/checking#/design-fto?task_id=$1' },
    // IP 相关路由重定向 drafting
    { pattern: /^\/ip\/home\?tab=ai_specification/, replacement: 'ip/#/home?agent=drafting' },
    { pattern: /^\/ip\/home(?=\/|$|\?)/, replacement: 'ip/#/home' },
    { pattern: /^\/ip\/specification\/([^/?]+)/, replacement: 'ip/checking/#/specification?taskId=$1' },
    { pattern: /^\/ai-drafting\/specification\/([^/?]+)/, replacement: 'ip/checking/#/specification?taskId=$1' },
    { pattern: /^\/drafting\/#\/specification/, replacement: 'ip/checking/#/specification' },
    { pattern: /^\/ip\/disclosure\/([^/?]+)/, replacement: 'ip/checking/#/disclosure?taskId=$1' },
    { pattern: /^\/ai-drafting\/disclosure\/([^/?]+)/, replacement: 'ip/checking/#/disclosure?taskId=$1' },
    { pattern: /^\/drafting\/#\/disclosure/, replacement: 'ip/checking/#/disclosure' },
    { pattern: /^\/ip\/translation\/([^/?]+)/, replacement: 'ip/checking/#/translation?taskId=$1' },
    { pattern: /^\/ai-drafting\/translation\/([^/?]+)/, replacement: 'ip/checking/#/translation?taskId=$1' },
    { pattern: /^\/drafting\/#\/translation/, replacement: 'ip/checking/#/translation' }
]

function getRedirectPath(path: string): string | null {
    for (const { pattern, replacement } of redirectRules) {
        if (pattern.test(path)) {
            return path.replace(pattern, replacement)
        }
    }
    return null
}

export const deprecatedRouter: RouteRecordRaw = {
    path: '/:catchAll(.*)',
    component: () => {},
    beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
        const newPath = getRedirectPath(to.fullPath)
        if (newPath) {
            const fullPath = new Site({ sld: SLD.EUREKA, pathname: newPath }).href
            window.location.replace(fullPath)
        } else {
            next('/404')
        }
    },
}
